import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { ContractDocument } from 'shared/types';

export function useGetDraftContract(id: string) {
  const { draftContractService } = useService();
  const { data, isLoading, isFetching } = useQuery<ContractDocument | undefined, Error>(['draft-contract', id], () =>
    draftContractService.getDraftContract(id)
  );

  return { draftContract: data, isLoading, isFetching } as const;
}
